import React from 'react';

class Checkbox extends React.Component {
  render() {
    const {label, value, onChange, labelType, inputType, markStyleClass, isLoading} = this.props;

    return (
      <label className={'ect-checkbox ' + labelType}>
        <input
          type='checkbox'
          id='ectCheckbox'
          className={`ect-checkbox-input ${inputType}`}
          checked={value ? 'checked' : ''}
          onChange={onChange}
        />
        <span
          className={`ect-checkbox-mark ${markStyleClass} ${
            isLoading ? '__spinner _border_none' : value ? 'checked' : ''
          }`}
        />
        <span className='ect-checkbox-label'>{label}</span>
      </label>
    );
  }
}

Checkbox.defaultProps = {
  label: '',
  value: false,
  onChange: () => {},
  inputType: 'checkbox',
  labelType: ''
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/app/Components/Checkbox.jsx